const initState = {
    isLoading: false,
    data: [],
    error: null,
}

export default function userDetail(state = initState, action) {
    switch (action.type) {
        case "SET_LOADING_ALL":
            return {
                ...state,
                isLoading: true,
            }
        case "SET_DATA_ALL":
            return {
                ...state,
                data: action.payload,
                isLoading: false,
            }
        case "SET_ERROR_ALL":
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            }
        case "SET_DATA_CLEAR":
            return {
                data: null,
                isLoading: false,
            }
        default:
            return state
    }
}